import { CACHE_TAG_TENANT_SETTINGS } from '../cacheTagTypes'
import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getTenantSettings: builder.query({
      query: () => ({ url: '/api/v1/tenant-settings' }),
      providesTags: [CACHE_TAG_TENANT_SETTINGS],
    }),
    updateTenantSettings: builder.mutation({
      query: body => {
        return { url: '/api/v1/tenant-settings', method: 'PUT', body }
      },
      invalidatesTags: [CACHE_TAG_TENANT_SETTINGS],
    }),
  }),
})

export const { useLazyGetTenantSettingsQuery, useUpdateTenantSettingsMutation } = extendedApi

export const getTenantSettingsSlice = extendedApi.endpoints.getTenantSettings.select()
